module.exports = __webpack_public_path__ + "img/1371282013.dbaa1765.jpg";